import React from 'react'
import { useTheme } from '@material-ui/core'
import { getAssignedUsersDisplay, UnitInspection } from '../../models'
import { AvatarCircle, Container, StatusBadge } from '../../components'

interface Props {
    unitInspection?: UnitInspection
    customStyle?: React.CSSProperties
    removeAvatarCircle?: boolean
    displayUser?: string
}

export const UnitInspectionStatusBadge = (props: Props) => {
    const { unitInspection, removeAvatarCircle, displayUser } = props

    const theme = useTheme()

    const BADGE_HEIGHT = 32

    let statusBadge: JSX.Element

    const displayUserText = displayUser
        ? displayUser
        : getAssignedUsersDisplay(
              unitInspection?.assigned_users,
              unitInspection?.assigned_to,
          )

    if (unitInspection) {
        statusBadge = (
            <Container
                style={{
                    alignItems: 'center',
                }}
            >
                {removeAvatarCircle ? (
                    <></>
                ) : (
                    <AvatarCircle
                        text={displayUserText}
                        initials
                        styles={{
                            container: {
                                marginRight: theme.spacing(1),
                                minHeight: 30,
                                minWidth: 30,
                                maxHeight: 30,
                                maxWidth: 30,
                            },
                        }}
                    />
                )}

                <StatusBadge
                    text={'Assigned'}
                    customStyle={{
                        container: {
                            height: BADGE_HEIGHT,
                            backgroundColor: theme.palette.secondary.main,
                            maxWidth: 90,
                            ...props.customStyle,
                        },
                        text: {
                            fontWeight: 700,
                        },
                    }}
                />
            </Container>
        )

        if (unitInspection.complete_status) {
            statusBadge = (
                <Container
                    style={{
                        alignItems: 'center',
                    }}
                >
                    {removeAvatarCircle ? (
                        <></>
                    ) : (
                        <AvatarCircle
                            text={displayUserText}
                            initials
                            styles={{
                                container: {
                                    marginRight: theme.spacing(1),
                                    minHeight: 30,
                                    minWidth: 30,
                                    maxHeight: 30,
                                    maxWidth: 30,
                                },
                            }}
                        />
                    )}
                    <StatusBadge
                        text={'Complete'}
                        customStyle={{
                            container: {
                                height: BADGE_HEIGHT,
                                ...props.customStyle,
                            },
                            text: {
                                fontWeight: 700,
                            },
                        }}
                    />
                </Container>
            )
        }
    } else {
        statusBadge = <></>
    }

    return statusBadge
}
